module.exports = __webpack_public_path__ + "static/media/delete.d0a6cc91.svg";